import messages from '@/lang'

export default {
  fiscalYearHeaders (locale) {
    return ([
      {
        sortable: false,
        text: messages[locale].status,
        value: 'status'
      },
      {
        sortable: true,
        text: messages[locale].startDate,
        value: 'startDate'
      },
      {
        sortable: true,
        text: messages[locale].endDate,
        value: 'endDate'
      },
      {
        sortable: false,
        text: messages[locale].actions,
        value: 'actions',
        align: 'center'
      }
    ])
  }
}
